import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '../../../../pipeline/models/global.models';

@Pipe({ name: 'getTagStyle' })
export class TagStylePipe implements PipeTransform {
  transform(tagGuid: string, styleProp: string, tagsStyles: Models.Tag[] = []): string {
    if (!(tagGuid && styleProp && tagsStyles)) {
      return '';
    }
    const tagStyle = tagsStyles.find((tag) => tag.guid === tagGuid);
    return tagStyle ? tagStyle[styleProp] : '';
  }
}
